<ng-template #status>
  <ng-container [ngSwitch]="paymentsTransactionResult$ | async">
    <div *ngSwitchCase="paymentState.declined" class="content-wrapper">
      <nx-message context="error" class="nx-margin-bottom-m">
        {{ 'payments.transaction.declined.message' | translate }}
      </nx-message>
      <p nxCopytext="normal"
         class="nx-margin-bottom-m">{{ 'payments.transaction.declined.description' | translate }}</p>
      <button nxButton class="nx-margin-bottom-xl" (click)="handleTryAgain()">
        {{ 'payments.transaction.declined.button' | translate }}
      </button>
      <p nxCopytext="normal">
        {{ 'payments.transaction.declined.description2' | translate }}
        <a href="https://zaloguj.allianz.pl/" nxPlainButton>{{ 'payments.transaction.declined.button2' | translate }}</a>
      </p>
    </div>
    <div *ngSwitchCase="paymentState.pending" class="content-wrapper">
      <nx-message context="warning" class="nx-margin-bottom-m">
        {{ 'payments.transaction.pending.message' | translate }}
      </nx-message>
      <p nxCopytext="normal" class="nx-margin-bottom-m">{{ 'payments.transaction.pending.description' | translate }}</p>
      <a href="https://zaloguj.allianz.pl/" nxButton="secondary" class="nx-margin-bottom-xl">
        {{ 'payments.transaction.pending.button' | translate }}
      </a>
      <p nxCopytext="normal" class="nx-margin-bottom-2xs">
        <b>{{ 'payments.transaction.pending.header2' | translate }}</b>
      </p>
      <p nxCopytext="normal">
        {{ 'payments.transaction.pending.description2' | translate }}
      </p>
    </div>
    <app-loader *ngSwitchDefault view="flex"></app-loader>
  </ng-container>
</ng-template>

<qbe-panel-component>
  <div class="payment-status-container">
    <ng-container [ngSwitch]="paymentsTransactionState$ | async">
      <ng-container *ngSwitchCase="apiState.error">
        <app-error [appError]="paymentsTransactionError$ | async"></app-error>
      </ng-container>
      <ng-container *ngSwitchCase="apiState.success">
        <ng-container *ngTemplateOutlet="status"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="apiState.pending">
        <ng-container [ngSwitch]="paymentsTransactionStatePrev$ | async">
          <ng-container *ngSwitchCase="apiState.error">
            <app-error [appError]="paymentsTransactionErrorPrev$ | async"></app-error>
          </ng-container>
          <div class="payment-status-prev" *ngSwitchCase="apiState.success">
            <ng-container *ngTemplateOutlet="status"></ng-container>
            <app-loader view="absolute"></app-loader>
          </div>
          <app-loader *ngSwitchDefault view="flex"></app-loader>
        </ng-container>
      </ng-container>
      <app-loader *ngSwitchDefault view="flex"></app-loader>
    </ng-container>
  </div>
</qbe-panel-component>
